import * as React from 'react';

const ChevronIcon = ({ className = '', onClick, style = {}, width = '24px', height = '20px' }) => (
    <svg className={`chevron-icon ${className}`} onClick={onClick} style={{...style, width, height}} xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 115.9 67.8">
        <g>
            <path d="M58,40.8c4-3.7,7.9-7.4,11.8-11.2c9-8.6,17.9-17.2,26.8-25.8c4.7-4.5,10.2-5.1,14.6-1.7c5.8,4.4,6.3,12.5,0.9,17.9
		c-5.5,5.5-11.1,10.8-16.7,16.2c-9.8,9.3-19.6,18.6-29.3,27.9c-5.1,4.9-11.3,4.9-16.4,0c-15.3-14.7-30.7-29.3-46-44
		C-2.3,14.2-0.8,4.7,6.6,1c4.1-2,8.7-1,12.9,3C25.3,9.5,31,15.1,36.8,20.7c6.8,6.5,13.6,13,20.4,19.5C57.4,40.4,57.7,40.6,58,40.8z"
            />
        </g>
    </svg>
);

export default ChevronIcon;